import cn from 'classnames'
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import s from './QuantitySelector.module.scss'
import formStyles from 'stores/ooka_default/styles/common/Forms.module.scss'
import { MinusIcon, PlusIcon, Trash } from '@components/icons'
import Toast from '../CenteredToast/Toast'
import { useUI } from '@corratech/pylot-ui/context'
import { useIsMobile } from '@components/common/IsMobile/useIsMobile'
// TODO: make `CartQuantity` component based on this one
// remove / add required props
type QuantitySelectorProps = {
    slots?: number
    quantity: number
    setQuantity:
        | Dispatch<SetStateAction<number>>
        | ((quantity?: number) => void)
    customMin?: boolean
    min?: number
    isAddingDisabled?: boolean
    setPodsFull?: Dispatch<SetStateAction<boolean>>
}

const MIN = 1
const MAX = 99

export const QuantitySelector = ({
    slots = 0,
    quantity,
    setQuantity,
    isAddingDisabled = false,
    setPodsFull,
    customMin = false,
    min = 0
}: QuantitySelectorProps): JSX.Element => {
    const [open, setOpen] = useState(false)
    const { navbarScrolled } = useUI()
    const isMobile = useIsMobile()

    const incrementQuantity = () => {
        if (isAddingDisabled) {
            setOpen(true)
            setTimeout(() => setOpen(false), 3000)
            setPodsFull?.(true)
            return
        }
        const newValue = Math.min(quantity + 1, MAX)
        setQuantity(newValue)
    }

    const decrementQuantity = () => {
        let newValue = Math.max(quantity - 1, MIN)
        if (customMin) {
            newValue = Math.max(quantity - 1, min)
        }
        setPodsFull?.(false)
        setQuantity(newValue)
    }

    const toastText = `You have already selected ${slots} pods.`

    return (
        <>
            <Toast
                isOpen={open}
                text={toastText}
                sticked={navbarScrolled && isMobile}
            />
            <div className={cn(s['pdp-quantity'], 'pdp-qty')}>
                <div className={formStyles.root}>
                    <button
                        className={cn('qty-label-left', 'qty-label')}
                        onClick={decrementQuantity}
                    >
                        {quantity! > 1 ? (
                            <div className={cn('qty-minus-icon')}>
                                <MinusIcon />
                            </div>
                        ) : (
                            <Trash />
                        )}
                    </button>
                    <input
                        type="text"
                        className="form-qty-indicator"
                        value={quantity}
                        readOnly
                    />
                    <button
                        className={cn('qty-label', 'qty-label-right', {
                            [s['qty-label-disabled']]: isAddingDisabled
                        })}
                        onClick={incrementQuantity}
                    >
                        <PlusIcon isHidden={isAddingDisabled} />
                    </button>
                </div>
            </div>
        </>
    )
}
